import { deliveryOptionsCodes } from "@/common/fields/delivery-options";
import { paymentMethodsCodesReader } from "@/common/fields/orders-payment-methods";
import { paymentStatusesCodes } from "@/common/fields/orders-payment-status-codes";
import { ordersStatusesCodes } from "@/common/fields/orders-status-codes";

export const slugify = (value = "") => {
    return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replaceAll(".", "")
        .replaceAll(",", "")
        .replaceAll(" ", "-");
};

export const validateConfirmationMessage = (str = "") => {
    return str.toLowerCase() === "si";
};

export const applyFormatOrder = (item) => ({
    ...item,
    deliveryStatusMessage:
        ordersStatusesCodes[item.deliveryStatus] || ordersStatusesCodes.pending,
    paymentStatusMessage:
        paymentStatusesCodes[item.paymentStatus] ||
        paymentStatusesCodes.pending,
    deliveryOptionMessage:
        deliveryOptionsCodes[item.deliveryOption] || deliveryOptionsCodes.home,
    paymentMethodMessage:
        paymentMethodsCodesReader[item.paymentMethod] ||
        paymentMethodsCodesReader.cash
});

export const removeEmptyFields = (obj = {}) => {
    return Object.fromEntries(
        Object.entries(obj).filter(
            ([, v]) => v !== "" && v !== null && v !== undefined
        )
    );
};

export const cutString = (value = "", limit, showPoints = false) => {
    if (!limit) {
        return value;
    }
    if (!value) {
        return "";
    }
    const valueStr = String(value).trim();
    return valueStr.length < limit - 3
        ? valueStr
        : `${valueStr.slice(0, limit - 3)} ${showPoints ? "..." : ""}`;
};
